import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, reaction } from "mobx";

class Competition {
  isSelected = false;
  isShown = false;
  notNew = true;
  constructor(
    id = uuidv4(),
    name = "", //coach
    date = Date(), //coach
    coach = null,
    client = null,
    weightClass = "",
    competitionClass = "", //coach
    competitionLevel = "", //coach
    localization = "", //de moment no
    weightIn = "",
    hour = "",
    goals = ["", "", ""],
    notes = "",
    topEnd = ["", "", ""],
    minimumMark = "",
    squatAttempts = [
      { good: "", medium: "", bad: "" },
      { good: "", medium: "", bad: "" },
      { good: "", medium: "", bad: "" },
    ],
    squatWarmups = ["", "", "", "", "", "", "", ""],
    benchAttempts = [
      { good: "", medium: "", bad: "" },
      { good: "", medium: "", bad: "" },
      { good: "", medium: "", bad: "" },
    ],
    benchWarmups = ["", "", "", "", "", "", "", ""],
    deadliftAttempts = [
      { good: "", medium: "", bad: "" },
      { good: "", medium: "", bad: "" },
      { good: "", medium: "", bad: "" },
    ],
    deadliftWarmups = ["", "", "", "", "", "", "", ""],
    squatResults = [
      { result: "", isNull: false },
      { result: "", isNull: false },
      { result: "", isNull: false },
    ],
    benchPressResults = [
      { result: "", isNull: false },
      { result: "", isNull: false },
      { result: "", isNull: false },
    ],
    deadliftResults = [
      { result: "", isNull: false },
      { result: "", isNull: false },
      { result: "", isNull: false },
    ],
    recapNotes = "",
    lastUpdate = null
  ) {
    this.id = id;
    this.name = name;
    this.date = date;
    this.coach = coach;
    this.client = client;
    this.weightClass = weightClass;
    this.competitionClass = competitionClass;
    this.competitionLevel = competitionLevel;
    this.localization = localization;
    this.weightIn = weightIn;
    this.hour = hour;
    this.goals = goals;
    this.notes = notes;
    this.topEnd = topEnd;
    this.minimumMark = minimumMark;

    this.squatAttempts = squatAttempts;
    this.squatWarmups = squatWarmups;
    this.benchAttempts = benchAttempts;
    this.benchWarmups = benchWarmups;
    this.deadliftAttempts = deadliftAttempts;
    this.deadliftWarmups = deadliftWarmups;

    this.squatResults = squatResults;
    this.benchPressResults = benchPressResults;
    this.deadliftResults = deadliftResults;
    this.recapNotes = recapNotes;
    this.lastUpdate = lastUpdate;
    makeAutoObservable(this);
    reaction(
      () => ({
        name: this.name,
        date: this.date,
        weightClass: this.weightClass,
        competitionClass: this.competitionClass,
        competitionLevel: this.competitionLevel,
        localization: this.localization,
        weightIn: this.weightIn,
        hour: this.hour,
        goals: this.goals, //no va
        notes: this.notes,
        topEnd: this.topEnd, //no va
        minimumMark: this.minimumMark,

        squatAttempts: this.squatAttempts, //no va
        squatWarmups: this.squatWarmups, //no va
        benchAttempts: this.benchAttempts, //no va
        benchWarmups: this.benchWarmups, //no va
        deadliftAttempts: this.deadliftAttempts, //no va
        deadliftWarmups: this.deadliftWarmups, //no va

        squatResults: this.squatResults, //no va
        benchPressResults: this.benchPressResults, //no va
        deadliftResults: this.deadliftResults, //no va
        recapNotes: this.recapNotes,
      }),
      (data) => {
        if (this.client && !this.client.avoidTransaction) {
          this.client.updateClientTransactionCompetitions(this.id);
          this.client.startOrResetBatchTimer();
        } else if (this.coach) {
          this.coach.updateCoachTransactionCompetitions(this.id);
          this.coach.startOrResetBatchTimer();
        }
      }
    );
  }

  updateCompetition(data) {
    if (!this.client.clientTransactionCompetitions.includes(this.id)) {
      const updates = {
        name: data.name,
        date: data.date?.toDate() ?? new Date(),
        competitionClass: data.competition_class,
        competitionLevel: data.competition_level,
        weightClass: data.weight_class,
        weightIn: data.weight_in,
        hour: data.hour,
        goals: data.goals,
        notes: data.notes,
        topEnd: data.top_end,
        minimumMark: data.minimum_mark,
        squatAttempts: data.squat_attempts,
        squatWarmups: data.squat_warmups,
        benchAttempts: data.bench_press_attempts,
        benchWarmups: data.bench_press_warmups,
        deadliftAttempts: data.deadlift_attempts,
        deadliftWarmups: data.deadlift_warmups,
        squatResults: data.squat_results,
        benchPressResults: data.bench_press_results,
        deadliftResults: data.deadlift_results,
        recapNotes: data.recap_notes,
      };

      Object.entries(updates).forEach(([key, newVal]) => {
        const oldVal = this[key];
        if (!Object.is(oldVal, newVal)) {
          this[key] = newVal;
          // console.log(`Updated ${key}:`, { old: oldVal, new: newVal });
        }
      });

      if (data.lastUpdate) {
        const oldLU = this.lastUpdate;
        const newLU = data.lastUpdate.toDate();
        if (!Object.is(oldLU, newLU)) {
          this.lastUpdate = newLU;
          // console.log("Updated lastUpdate:", { old: oldLU, new: newLU });
        }
      }
    }
  }

  attemptValue(exercise, index, property) {
    if (exercise === "squat") {
      if (property === "good") {
        return this.squatAttempts[index].good;
      } else if (property === "medium") {
        return this.squatAttempts[index].medium;
      } else {
        return this.squatAttempts[index].bad;
      }
    } else if (exercise === "bench press") {
      if (property === "good") {
        return this.benchAttempts[index].good;
      } else if (property === "medium") {
        return this.benchAttempts[index].medium;
      } else {
        return this.benchAttempts[index].bad;
      }
    } else {
      if (property === "good") {
        return this.deadliftAttempts[index].good;
      } else if (property === "medium") {
        return this.deadliftAttempts[index].medium;
      } else {
        return this.deadliftAttempts[index].bad;
      }
    }
  }

  setAttempt(exercise, index, property, value) {
    if (exercise === "squat") {
      if (property === "good") {
        this.squatAttempts[index].good = value;
      } else if (property === "medium") {
        this.squatAttempts[index].medium = value;
      } else {
        this.squatAttempts[index].bad = value;
      }
    } else if (exercise === "bench press") {
      if (property === "good") {
        this.benchAttempts[index].good = value;
      } else if (property === "medium") {
        this.benchAttempts[index].medium = value;
      } else {
        this.benchAttempts[index].bad = value;
      }
    } else {
      if (property === "good") {
        this.deadliftAttempts[index].good = value;
      } else if (property === "medium") {
        this.deadliftAttempts[index].medium = value;
      } else {
        this.deadliftAttempts[index].bad = value;
      }
    }
    if (this.client) {
      // console.log("QUE BEEEE");
      this.client.updateClientTransactionCompetitions(this.id);
      this.client.startOrResetBatchTimer();
    } else {
      // console.log("QUE PASAAAA");
    }
  }

  topEndValue(exercise) {
    if (exercise === "squat") {
      return this.topEnd[0];
    } else if (exercise === "bench press") {
      return this.topEnd[1];
    } else {
      return this.topEnd[2];
    }
  }

  setTopEnd(exercise, value) {
    if (exercise === "squat") {
      this.topEnd[0] = value;
    } else if (exercise === "bench press") {
      this.topEnd[1] = value;
    } else {
      this.topEnd[2] = value;
    }
    if (this.client) {
      // console.log("QUE BEEEE");
      this.client.updateClientTransactionCompetitions(this.id);
      this.client.startOrResetBatchTimer();
    } else {
      // console.log("QUE PASAAAA");
    }
  }

  warmupValue(exercise, warmupIndex) {
    if (exercise === "squat") {
      return this.squatWarmups[warmupIndex];
    } else if (exercise === "bench press") {
      return this.benchWarmups[warmupIndex];
    } else {
      return this.deadliftWarmups[warmupIndex];
    }
  }

  setWarmup(exercise, warmupIndex, value) {
    if (exercise === "squat") {
      this.squatWarmups[warmupIndex] = value;
    } else if (exercise === "bench press") {
      this.benchWarmups[warmupIndex] = value;
    } else {
      this.deadliftWarmups[warmupIndex] = value;
    }
    if (this.client) {
      // console.log("QUE BEEEE");
      this.client.updateClientTransactionCompetitions(this.id);
      this.client.startOrResetBatchTimer();
    } else {
      // console.log("QUE PASAAAA");
    }
  }

  setGoal(goalIndex, value) {
    this.goals[goalIndex] = value;
    if (this.client) {
      // console.log("QUE BEEEE");
      this.client.updateClientTransactionCompetitions(this.id);
      this.client.startOrResetBatchTimer();
    } else {
      // console.log("QUE PASAAAA");
    }
  }

  getTotal(totalIndex) {
    const sum =
      Number(
        totalIndex === 0
          ? this.squatAttempts[2].good
          : totalIndex === 1
          ? this.squatAttempts[2].medium
          : this.squatAttempts[2].bad
      ) +
      Number(
        totalIndex === 0
          ? this.benchAttempts[2].good
          : totalIndex === 1
          ? this.benchAttempts[2].medium
          : this.benchAttempts[2].bad
      ) +
      Number(
        totalIndex === 0
          ? this.deadliftAttempts[2].good
          : totalIndex === 1
          ? this.deadliftAttempts[2].medium
          : this.deadliftAttempts[2].bad
      );

    return this.customRound(sum);
  }
  getMaxValidResult(results) {
    // Filter out results where isNull is true or result is empty
    const validResults = results.filter(
      (item) => !item.isNull && item.result !== ""
    );
    // Map to numbers and get the maximum value
    const maxResult = validResults.reduce((max, item) => {
      const resultNumber = Number(item.result);
      return resultNumber > max ? resultNumber : max;
    }, 0); // start with 0, which also handles cases where there are no valid results
    return maxResult;
  }

  getValidAttempts(results, isNull) {
    // Filter out results where isNull is true or result is empty
    const validResults = results.filter(
      (item) => item.isNull === isNull && item.result !== ""
    );
    return validResults.length;
  }

  getValidThirdAttempts(results, isNull) {
    if (results[2].isNull === isNull && results[2].result !== "") {
      return 1;
    } else {
      return 0;
    }
  }

  get recapTotal() {
    // Get the maximum valid result for each exercise
    const maxSquat = this.getMaxValidResult(this.squatResults);
    const maxBenchPress = this.getMaxValidResult(this.benchPressResults);
    const maxDeadlift = this.getMaxValidResult(this.deadliftResults);

    // Sum the maximum values
    const sum = maxSquat + maxBenchPress + maxDeadlift;

    // Assuming customRound is a method that rounds the total sum as required
    return this.customRound(sum);
  }

  getMinimumDiff(totalIndex) {
    return this.getTotal(totalIndex) - Number(this.minimumMark);
  }

  customRound(value) {
    const nearest = 2.5;
    return Math.round(value / nearest) * nearest;
  }

  recapAttemptValue(exercise, index, property) {
    if (exercise === "squat") {
      if (property === "result") {
        return this.squatResults[index].result;
      } else {
        return this.squatResults[index].isNull;
      }
    } else if (exercise === "bench press") {
      if (property === "result") {
        return this.benchPressResults[index].result;
      } else {
        return this.benchPressResults[index].isNull;
      }
    } else {
      if (property === "result") {
        return this.deadliftResults[index].result;
      } else {
        return this.deadliftResults[index].isNull;
      }
    }
  }

  setRecapAttempt(exercise, index, property, value) {
    if (exercise === "squat") {
      if (property === "result") {
        this.squatResults[index].result = value;
      } else {
        this.squatResults[index].isNull = !this.squatResults[index].isNull;
      }
    } else if (exercise === "bench press") {
      if (property === "result") {
        this.benchPressResults[index].result = value;
      } else {
        this.benchPressResults[index].isNull =
          !this.benchPressResults[index].isNull;
      }
    } else {
      if (property === "result") {
        this.deadliftResults[index].result = value;
      } else {
        this.deadliftResults[index].isNull =
          !this.deadliftResults[index].isNull;
      }
    }
    if (this.client) {
      // console.log("QUE BEEEE");
      this.client.updateClientTransactionCompetitions(this.id);
      this.client.startOrResetBatchTimer();
    } else {
      // console.log("QUE PASAAAA");
    }
  }

  isSameDay = (date1, date2) => {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  weeksOut(t) {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today's date

    const competitionDate = new Date(this.date);
    competitionDate.setHours(0, 0, 0, 0); // Normalize competition date

    // Calculate the start of the week (Monday) for 'today'
    const startOfCurrentWeek = new Date(today);
    const dayOfWeekToday = today.getDay();
    const daysToMonday = dayOfWeekToday === 0 ? 6 : dayOfWeekToday - 1;
    startOfCurrentWeek.setDate(today.getDate() - daysToMonday);

    // Calculate the start of the week (Monday) for the competition date
    const startOfCompetitionWeek = new Date(competitionDate);
    const dayOfWeekCompetition = competitionDate.getDay();
    const daysToMondayCompetition =
      dayOfWeekCompetition === 0 ? 6 : dayOfWeekCompetition - 1;
    startOfCompetitionWeek.setDate(
      competitionDate.getDate() - daysToMondayCompetition
    );

    if (competitionDate < today) {
      return t("alreadyHappened-string");
    } else if (competitionDate.getTime() === today.getTime()) {
      return t("isToday-string");
    } else if (
      startOfCurrentWeek.getTime() === startOfCompetitionWeek.getTime()
    ) {
      return t("isThisWeek-string");
    } else {
      // Calculate the number of weeks between the current week and the competition week
      const millisecondsPerWeek = 1000 * 60 * 60 * 24 * 7;
      let weeks = Math.floor(
        (startOfCompetitionWeek - startOfCurrentWeek) / millisecondsPerWeek
      );

      // Return formatted message
      if (weeks === 1) {
        return t("oneWeekLeft-string");
      } else {
        return t("someWeeksLeft-string", { weeks: weeks });
      }
    }
  }

  weeksOutAndName(t) {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today's date

    const competitionDate = new Date(this.date);
    competitionDate.setHours(0, 0, 0, 0); // Normalize competition date

    // Calculate the start of the week (Monday) for 'today'
    const startOfCurrentWeek = new Date(today);
    const dayOfWeekToday = today.getDay();
    const daysToMonday = dayOfWeekToday === 0 ? 6 : dayOfWeekToday - 1;
    startOfCurrentWeek.setDate(today.getDate() - daysToMonday);

    // Calculate the start of the week (Monday) for the competition date
    const startOfCompetitionWeek = new Date(competitionDate);
    const dayOfWeekCompetition = competitionDate.getDay();
    const daysToMondayCompetition =
      dayOfWeekCompetition === 0 ? 6 : dayOfWeekCompetition - 1;
    startOfCompetitionWeek.setDate(
      competitionDate.getDate() - daysToMondayCompetition
    );

    if (competitionDate < today) {
      return t("alreadyHappened-string");
    } else if (competitionDate.getTime() === today.getTime()) {
      return t("isTodayName-string", { name: this.name });
    } else if (
      startOfCurrentWeek.getTime() === startOfCompetitionWeek.getTime()
    ) {
      return t("isThisWeekName-string", { name: this.name });
    } else {
      // Calculate the number of weeks between the current week and the competition week
      const millisecondsPerWeek = 1000 * 60 * 60 * 24 * 7;
      let weeks = Math.floor(
        (startOfCompetitionWeek - startOfCurrentWeek) / millisecondsPerWeek
      );

      // Return formatted message
      if (weeks === 1) {
        return t("oneWeekLeftName-string", { name: this.name });
      } else {
        return t("someWeeksLeftName-string", { weeks: weeks, name: this.name });
      }
    }
  }

  totalValidAttempts(t) {
    if (this.coach) {
      let totalAttempts = 0;
      let totalValidAttempts = 0;
      this.coach.clientsInComp(this).forEach((client) => {
        const competition = client.competitions.find((c) => c.id === this.id);

        const squatValidResults = competition.getValidAttempts(
          competition.squatResults,
          false
        );
        const benchValidResults = competition.getValidAttempts(
          competition.benchPressResults,
          false
        );
        const deadliftValidResults = competition.getValidAttempts(
          competition.deadliftResults,
          false
        );

        const squatNullResults = competition.getValidAttempts(
          competition.squatResults,
          true
        );
        const benchNullResults = competition.getValidAttempts(
          competition.benchPressResults,
          true
        );
        const deadliftNullResults = competition.getValidAttempts(
          competition.deadliftResults,
          true
        );

        // Sum the maximum values
        const validAttempts =
          squatValidResults + benchValidResults + deadliftValidResults;

        const nullAttempts =
          squatNullResults + benchNullResults + deadliftNullResults;

        totalValidAttempts += validAttempts;
        totalAttempts += validAttempts + nullAttempts;
      });
      return t("totalValidAttempts-string", {
        totalValidAttempts: totalValidAttempts,
        totalAttempts: totalAttempts,
      });
    }
  }

  totalValidThirdAttempts(t) {
    if (this.coach) {
      let totalAttempts = 0;
      let totalValidAttempts = 0;
      this.coach.clientsInComp(this).forEach((client) => {
        const competition = client.competitions.find((c) => c.id === this.id);

        const squatValidResults = competition.getValidThirdAttempts(
          competition.squatResults,
          false
        );
        const benchValidResults = competition.getValidThirdAttempts(
          competition.benchPressResults,
          false
        );
        const deadliftValidResults = competition.getValidThirdAttempts(
          competition.deadliftResults,
          false
        );

        const squatNullResults = competition.getValidThirdAttempts(
          competition.squatResults,
          true
        );
        const benchNullResults = competition.getValidThirdAttempts(
          competition.benchPressResults,
          true
        );
        const deadliftNullResults = competition.getValidThirdAttempts(
          competition.deadliftResults,
          true
        );

        // Sum the maximum values
        const validAttempts =
          squatValidResults + benchValidResults + deadliftValidResults;

        const nullAttempts =
          squatNullResults + benchNullResults + deadliftNullResults;

        totalValidAttempts += validAttempts;
        totalAttempts += validAttempts + nullAttempts;
      });
      return t("totalValidThirdAttempts-string", {
        totalValidAttempts: totalValidAttempts,
        totalAttempts: totalAttempts,
      });
    }
  }

  getMaxResult(basicExercise) {
    const getMaxFromResults = (results) => {
      const validResults = results.filter((r) => !r.isNull);
      if (validResults.length === 0) return 0; // No valid results
      return Math.max(...validResults.map((r) => Number(r.result)));
    };

    if (basicExercise === "squat") {
      return getMaxFromResults(this.squatResults);
    } else if (basicExercise === "benchPress") {
      return getMaxFromResults(this.benchPressResults);
    } else if (basicExercise === "deadlift") {
      return getMaxFromResults(this.deadliftResults);
    } else {
      console.warn(`Invalid exercise type: ${basicExercise}`);
      return 0; // Return null for invalid exercise types
    }
  }

  uploadToCloud(timestamp = null) {
    if (this.coach) {
      return {
        id: this.id.toString().toLowerCase(),
        name: this.name,
        date: this.date,
        competition_class: this.competitionClass,
        competition_level: this.competitionLevel,
      };
    } else {
      const data = {
        id: this.id.toString().toLowerCase(),
        name: this.name,
        date: this.date,
        competition_class: this.competitionClass,
        competition_level: this.competitionLevel,

        weight_class: this.weightClass,
        weight_in: this.weightIn,
        hour: this.hour,
        goals: this.goals,
        notes: this.notes,
        top_end: this.topEnd,
        minimum_mark: this.minimumMark,

        squat_attempts: this.squatAttempts,
        squat_warmups: this.squatWarmups,
        bench_press_attempts: this.benchAttempts,
        bench_press_warmups: this.benchWarmups,
        deadlift_attempts: this.deadliftAttempts,
        deadlift_warmups: this.deadliftWarmups,

        squat_results: this.squatResults,
        bench_press_results: this.benchPressResults,
        deadlift_results: this.deadliftResults,
        recap_notes: this.recapNotes,

        modified_by:
          this.client && this.client.coach && this.client.coach.sessionId,
      };
      if (timestamp) {
        data.last_update = timestamp;
      }
      return data;
    }
  }

  updateFirestoreCompetitionData(competitionDocData, timestamp = null) {
    // Update basic properties
    competitionDocData["id"] = this.id.toString().toLowerCase();
    competitionDocData["name"] = this.name;
    competitionDocData["date"] = this.date;
    competitionDocData["competition_class"] = this.competitionClass;
    competitionDocData["competition_level"] = this.competitionLevel;

    // Update additional properties
    competitionDocData["weight_class"] = this.weightClass;
    competitionDocData["weight_in"] = this.weightIn;
    competitionDocData["hour"] = this.hour;
    competitionDocData["goals"] = this.goals;
    competitionDocData["notes"] = this.notes;
    competitionDocData["top_end"] = this.topEnd;
    competitionDocData["minimum_mark"] = this.minimumMark;

    // Update attempt arrays and results
    competitionDocData["squat_attempts"] = this.squatAttempts;
    competitionDocData["squat_warmups"] = this.squatWarmups;
    competitionDocData["bench_press_attempts"] = this.benchAttempts;
    competitionDocData["bench_press_warmups"] = this.benchWarmups;
    competitionDocData["deadlift_attempts"] = this.deadliftAttempts;
    competitionDocData["deadlift_warmups"] = this.deadliftWarmups;

    competitionDocData["squat_results"] = this.squatResults;
    competitionDocData["bench_press_results"] = this.benchPressResults;
    competitionDocData["deadlift_results"] = this.deadliftResults;
    competitionDocData["recap_notes"] = this.recapNotes;
    competitionDocData["modified_by"] =
      this?.client?.coach?.sessionId ?? "482549fd-2610-430a-9c54-956708000f6b";

    if (timestamp) {
      competitionDocData["last_update"] = timestamp;
    }
  }

  setIsSelected(value) {
    this.isSelected = value;
  }

  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }

  // Generic getter
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default Competition;
